import { useState } from 'react';

const ago = (iso) => {
  if (!iso) return '—';
  const d = Math.floor((Date.now() - new Date(iso)) / 86400000);
  return d <= 0 ? 'hoy' : d === 1 ? 'ayer' : `hace ${d} días`;
};

export const appState = (st) => {
  const installed = !!st?.installed;
  const push = (st?.push_devices || 0) > 0 && st?.notif_permission === 'granted';
  const denied = st?.notif_permission === 'denied';
  return { installed, push, denied };
};

export function AppBadges({ st, Badge }) {
  const { installed, push, denied } = appState(st);
  return (
    <>
      {installed ? <Badge color="green">App ✓</Badge> : <Badge color="gray">Sin app</Badge>}
      {installed && (push ? <Badge color="sky">🔔 Notif.</Badge> : denied ? <Badge color="red">Notif. bloqueadas</Badge> : <Badge color="orange">Sin notif.</Badge>)}
    </>
  );
}

export default function AppStatusModal({ employees, status, onClose }) {
  const [f, setF] = useState('all');
  const rows = employees.map((e) => ({ e, st: status[e.id], ...appState(status[e.id]) }));
  const tot = { all: rows.length, app: rows.filter((r) => r.installed).length, push: rows.filter((r) => r.push).length };
  const list = rows.filter((r) => f === 'all' || (f === 'app' && r.installed) || (f === 'noapp' && !r.installed) || (f === 'push' && r.push) || (f === 'nopush' && !r.push));
  const Chip = ({ id, label }) => (
    <button onClick={() => setF(id)} className={`px-3 py-1.5 rounded-full text-xs font-bold whitespace-nowrap ${f === id ? 'bg-sky-600 text-white' : 'bg-gray-100 text-gray-500'}`}>{label}</button>
  );
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="relative bg-white w-full max-w-lg rounded-t-3xl sm:rounded-3xl shadow-2xl max-h-[88vh] flex flex-col">
        <div className="p-5 pb-3 border-b border-gray-100">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-bold text-gray-900">App y notificaciones</h3>
            <button onClick={onClose} className="text-gray-400 text-xl px-1">✕</button>
          </div>
          <p className="text-xs text-gray-400 mt-1">{tot.app} de {tot.all} instalaron la app · {tot.push} con notificaciones activas</p>
          <div className="flex gap-2 mt-3 overflow-x-auto pb-1">
            <Chip id="all" label="Todos" /><Chip id="app" label="Con app" /><Chip id="noapp" label="Sin app" /><Chip id="push" label="Con notif." /><Chip id="nopush" label="Sin notif." />
          </div>
        </div>
        <div className="overflow-y-auto p-3 space-y-2">
          {list.length === 0 && <p className="text-center text-sm text-gray-400 py-8">Nadie en esta lista.</p>}
          {list.map(({ e, st, installed, push, denied }) => (
            <div key={e.id} className="flex items-center gap-3 p-3 rounded-2xl bg-gray-50">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-gray-900 truncate">{e.name}</p>
                <p className="text-[11px] text-gray-400">
                  {installed ? `App instalada · última vez ${ago(st?.last_app_seen)}${st?.platform ? ` · ${st.platform}` : ''}` : 'Todavía no instaló la app'}
                </p>
              </div>
              <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full ${push ? 'bg-emerald-50 text-emerald-700' : denied ? 'bg-red-50 text-red-600' : installed ? 'bg-amber-50 text-amber-700' : 'bg-gray-100 text-gray-400'}`}>
                {push ? '🔔 Activadas' : denied ? 'Bloqueadas' : installed ? 'Sin aceptar' : '—'}
              </span>
            </div>
          ))}
        </div>
        <p className="text-[11px] text-gray-400 px-5 py-3 border-t border-gray-100">Si alguien bloqueó las notificaciones, tiene que habilitarlas desde los ajustes de su teléfono. La app vuelve a pedirlas cada 2 días a quien aún no aceptó.</p>
      </div>
    </div>
  );
}
